import { render, staticRenderFns } from "./SharePublic.vue?vue&type=template&id=e5bce48c&"
import script from "./SharePublic.vue?vue&type=script&lang=ts&"
export * from "./SharePublic.vue?vue&type=script&lang=ts&"
import style0 from "./SharePublic.vue?vue&type=style&index=0&id=e5bce48c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports